module.exports = __webpack_public_path__ + "img/Krankenhaus.bfd2b757.svg";